module.exports = __webpack_public_path__ + "static/img/11.34fc89da.png";